import { Fade } from 'react-awesome-reveal';
import { LayoutSectionComponentType } from 'types';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import VideoBox from 'components/videoBox/VideoBox';
import GridBox from 'components/gridBox/GridBox';
import ContactFormSection from 'components/contactForm/ContactFormSection';
import Slider from 'react-slick';
import LogoTable from 'components/logoTable/LogoTable';
import EventGridSlider from 'components/eventGridSlider/EventGridSlider';
import useViewport from 'hooks/useViewport';
import BlogGridSlider from 'components/blogGridSlider/BlogGridSlider';
import 'swiper/css';
import 'swiper/css/effect-cards';
import Member from 'components/member/Member';
import Whatsapp from 'components/whatsapp/Whatsapp';
import FeatureAlbum from 'pages/home/FeatureAlbum';
import Mailchimp from 'components/mailchimp/Mailchimp';
import InstagramSection from 'components/instagramSection/InstagramSection';
import HeroMediaSliderSection from 'components/heroMediaSliderSection/heroMediaSliderSection';
import Albums from 'pages/albums/Albums';
// import MagicGrid from 'magic-grid';

interface LayoutBlockProps {
  layoutSectionBlocksData?: LayoutSectionComponentType;
}
// testimonialSelection,
export default function LayoutBlocks({
  layoutSectionBlocksData,
}: LayoutBlockProps) {
  const { isMobile } = useViewport();
  if (!layoutSectionBlocksData) return <div />;
  const { layoutSectionContent } =
    layoutSectionBlocksData as LayoutSectionComponentType;
  const TotalColumn = layoutSectionContent.length;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };
  // const { sliderGallery } = layoutSectionContent as LayoutSectionComponentType;
  // const finalImages = layoutSectionContent.map(layoutSectionContentItem =>
  //   layoutSectionContentItem?.sliderGallery?.map(
  //     (image: { url: any }) => image.url,
  //   ),
  // );

  return (
    <div className="w-full">
      <div className="flex flex-wrap h-full" style={{ alignItems: 'stretch' }}>
        {layoutSectionContent?.map(layoutSectionContentItem => (
          <div
            key={Math.random()}
            id={
              layoutSectionContentItem?.htmlIdWrapper ||
              `section-${Math.floor(Math.random() * 25)}`
            }
            className={`flex justify-center mx-0 px-0
              ${`w-full xl:w-${12 / TotalColumn}`}
            `}>
            <div
              className={`flex dynamic-feature-section background-image-featured w-full flex-column ${
                layoutSectionContentItem.cssClassWrapper
              } ${layoutSectionContentItem?.backgroundImage ? 'tinted' : ''}`}
              style={{
                backgroundImage:
                  layoutSectionContentItem?.backgroundImage &&
                  `url(${layoutSectionContentItem.backgroundImage.url})`,
                flex: '1 1 auto',
              }}>
              <section
                className={`container mx-auto relative z-2 w-10 ${
                  layoutSectionContentItem?.hideSection ? 'hidden' : ''
                }`}>
                <div className="grid mx-auto">
                  {layoutSectionContentItem?.textContent
                    ?.filter(textContent => textContent.contentAlign === 'card')
                    .map(textContentItem => (
                      <div
                        key={Math.random()}
                        className="col-12 md:col-3 md:mx-auto">
                        {textContentItem?.link ? (
                          <div>
                            {textContentItem.link.includes('http') ? (
                              <a
                                href={textContentItem?.link}
                                target="_blank"
                                className="flex flex-row p-2 align-items-start no-underline border-0 hover:border-1"
                                rel="noreferrer">
                                {textContentItem?.contentImage && (
                                  <img
                                    className="block m-0 p-0 border-round"
                                    style={{
                                      objectFit: 'cover',
                                      height: '70px',
                                      width: '70px',
                                      minHeight: '70px',
                                      minWidth: '70px',
                                    }}
                                    src={textContentItem.contentImage.url}
                                    alt={textContentItem?.header?.html || ''}
                                  />
                                )}
                                <div className="flex flex-column ml-3">
                                  {textContentItem?.header && (
                                    <h2 className="text-sm font-bold my-0 py-0 parsed-mb-0">
                                      {parse(textContentItem.header.html)}
                                    </h2>
                                  )}
                                  {textContentItem?.subHeader && (
                                    <h3 className="text-sm my-0 font-light opacity-90 py-0 parsed-mb-0">
                                      {parse(textContentItem.subHeader.html)}
                                    </h3>
                                  )}
                                  {textContentItem?.content && (
                                    <div className="body-parsed-text text-xs my-0 opacity-70 py-0 parsed-mb-0 w-11">
                                      {parse(textContentItem.content.html)}
                                    </div>
                                  )}
                                </div>
                              </a>
                            ) : (
                              <Link
                                to={textContentItem?.link}
                                className="flex flex-row p-2 align-items-start no-underline border-0 hover:border-1">
                                {textContentItem?.contentImage && (
                                  <img
                                    className="block m-0 p-0 border-round"
                                    style={{
                                      objectFit: 'cover',
                                      height: '70px',
                                      width: '70px',
                                      minHeight: '70px',
                                      minWidth: '70px',
                                    }}
                                    src={textContentItem.contentImage.url}
                                    alt={textContentItem?.header?.html || ''}
                                  />
                                )}
                                <div className="flex flex-column ml-3">
                                  {textContentItem?.header && (
                                    <h2 className="text-sm font-bold my-0 py-0 parsed-mb-0">
                                      {parse(textContentItem.header.html)}
                                    </h2>
                                  )}
                                  {textContentItem?.subHeader && (
                                    <h3 className="text-sm my-0 font-light opacity-90 py-0 parsed-mb-0">
                                      {parse(textContentItem.subHeader.html)}
                                    </h3>
                                  )}
                                  {textContentItem?.content && (
                                    <div className="body-parsed-text text-xs my-0 opacity-70 py-0 parsed-mb-0 w-11">
                                      {parse(textContentItem.content.html)}
                                    </div>
                                  )}
                                </div>
                              </Link>
                            )}
                          </div>
                        ) : (
                          <div className="flex flex-row p-2 align-items-start">
                            {textContentItem?.contentImage && (
                              <img
                                className={`block mb-0 ${textContentItem?.imageStyle?.map(
                                  imageStyleItem =>
                                    ` dynamic-image-class dynamic-${imageStyleItem} `,
                                )}`}
                                style={{
                                  objectFit: 'cover',
                                  height: '70px',
                                  width: '70px',
                                  minHeight: '70px',
                                  minWidth: '70px',
                                }}
                                src={textContentItem.contentImage.url}
                                alt={textContentItem?.header?.html || ''}
                              />
                            )}
                            <div className="flex flex-column ml-3">
                              {textContentItem?.header && (
                                <h2 className="text-sm font-bold my-0 py-0 parsed-mb-0">
                                  {parse(textContentItem.header.html)}
                                </h2>
                              )}
                              {textContentItem?.subHeader && (
                                <h3 className="text-sm my-0 font-light opacity-90 py-0 parsed-mb-0">
                                  {parse(textContentItem.subHeader.html)}
                                </h3>
                              )}
                              {textContentItem?.content && (
                                <div className="body-parsed-text text-xs my-0 opacity-70 py-0 parsed-mb-0 w-12">
                                  {parse(textContentItem.content.html)}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
                {layoutSectionContentItem?.textContent
                  ?.filter(textContent => textContent.contentAlign !== 'card')
                  .map(textContentItem => (
                    <div key={Math.random()} className="">
                      <div
                        className={`${textContentItem?.textContentWidth} ${
                          (textContentItem?.contentAlign === 'center' &&
                            'mx-auto') ||
                          (textContentItem?.contentAlign === 'left' &&
                            'mr-auto') ||
                          (textContentItem?.contentAlign === 'right' &&
                            'ml-auto') ||
                          (textContentItem?.contentAlign === 'justify' &&
                            'mx-auto')
                        } ${
                          (textContentItem?.textContentWidth === 'Content' &&
                            'w-full md:w-6') ||
                          (textContentItem?.textContentWidth === 'Full' &&
                            'w-full md:w-10')
                        }`}>
                        {textContentItem?.contentImage && (
                          <Fade direction="up" triggerOnce>
                            <img
                              className={`block mb-0 ${
                                (textContentItem?.contentAlign === 'center' &&
                                  'mx-auto') ||
                                (textContentItem?.contentAlign === 'left' &&
                                  'mr-auto') ||
                                (textContentItem?.contentAlign === 'right' &&
                                  'ml-auto') ||
                                (textContentItem?.contentAlign === 'justify' &&
                                  'mx-auto')
                              } ${textContentItem?.imageStyle?.map(
                                imageStyleItem =>
                                  ` dynamic-image-class dynamic-${imageStyleItem} `,
                              )}`}
                              style={{ objectFit: 'contain' }}
                              src={textContentItem.contentImage.url}
                              alt={textContentItem?.header?.html || ''}
                            />
                          </Fade>
                        )}
                        {textContentItem?.header && (
                          <Fade direction="up" triggerOnce>
                            <h2>{parse(textContentItem.header.html)}</h2>
                          </Fade>
                        )}
                        {textContentItem?.subHeader && (
                          <Fade direction="up" triggerOnce>
                            <h3>{parse(textContentItem.subHeader.html)}</h3>
                          </Fade>
                        )}
                        {textContentItem?.content && (
                          <Fade direction="up" triggerOnce>
                            <div className="body-parsed-text">
                              {parse(textContentItem.content.html)}
                            </div>
                          </Fade>
                        )}
                      </div>
                    </div>
                  ))}
                <div className="flex flex-row flex-wrap justify-content-center align-items-center mx-auto">
                  {layoutSectionContentItem?.callToAction?.map(
                    callToActionItem => (
                      <div key={Math.random()}>
                        {callToActionItem?.ctaLink && (
                          <div className="flex">
                            {callToActionItem?.ctaLink.includes('http') ? (
                              <a
                                href={callToActionItem?.ctaLink}
                                target="_blank"
                                className={`${callToActionItem.ctaClass} ${
                                  callToActionItem?.ctaPrimary
                                    ? 'theme-border-white text-white border-1 px-4 md:px-6 py-2 theme-button max-w-max block no-underline my-4 font-bold w-full text-2xl'
                                    : 'text-white border-0 px-4 md:px-6 py-2 theme-button max-w-max block no-underline my-4 w-full text-2xl'
                                } mr-2 max-w-max`}
                                rel="noreferrer">
                                {callToActionItem.ctaLabel}
                              </a>
                            ) : (
                              <Link
                                to={callToActionItem?.ctaLink}
                                className={`${callToActionItem.ctaClass} ${
                                  callToActionItem?.ctaPrimary
                                    ? 'theme-border-white text-white border-1 px-4 md:px-6 py-2 theme-button max-w-max block no-underline my-4 font-bold w-full text-2xl'
                                    : 'text-white border-0 px-4 md:px-6 py-2 theme-button max-w-max block no-underline my-4 w-full text-2xl'
                                } mr-2 max-w-max`}>
                                {callToActionItem.ctaLabel}
                              </Link>
                            )}
                          </div>
                        )}
                      </div>
                    ),
                  )}
                </div>
                {layoutSectionContentItem?.videoBox && (
                  <div>
                    {layoutSectionContentItem.videoBox?.map(video => (
                      <VideoBox
                        videoTitle={video?.videoTitle}
                        vimeoVideoId={video?.vimeoVideoId}
                        youtubeVideoId={video?.youtubeVideoId}
                        youtubePlaylistId={video?.youtubePlaylistId}
                        key={Math.random()}
                      />
                    ))}
                  </div>
                )}
                {layoutSectionContentItem?.eventSection && (
                  <section className="container my-8">
                    <h2 className="text-3xl md:text-6xl my-2 text-center">
                      {layoutSectionContentItem.eventSection
                        ?.eventSectionTitle &&
                        layoutSectionContentItem.eventSection.eventSectionTitle}
                    </h2>
                    <EventGridSlider
                      displayEventsStyleGridOrSlider={
                        layoutSectionContentItem?.eventSection?.eventDisplayType?.toLowerCase() ||
                        'grid'
                      }
                    />
                  </section>
                )}
                {layoutSectionContentItem?.gridBox && (
                  <GridBox gridBoxData={layoutSectionContentItem.gridBox} />
                )}
                {!!layoutSectionContentItem?.iFrameCode && (
                  <h2 className="font-bold my-4 py-0 text-center mx-auto">
                    {layoutSectionContentItem.iFrameTitle}
                  </h2>
                )}
                {!!layoutSectionContentItem?.iFrameCode && (
                  <div className="theme-bg-black">
                    {parse(layoutSectionContentItem.iFrameCode)}
                  </div>
                )}
              </section>
            </div>
          </div>
        ))}
      </div>
      {layoutSectionContent?.map(layoutSectionContentItem => (
        <div key={Math.random()} className="w-full">
          {layoutSectionContentItem?.parallaxImage?.url && (
            <div className="parallax-container accent">
              <div
                className="image-parallax"
                style={{
                  backgroundImage: `url(${layoutSectionContentItem.parallaxImage.url})`,
                }}
              />
            </div>
          )}
          {layoutSectionContentItem?.galleryLayout === 'grid' ? (
            <div className="my-8">
              {/* {!!finalImages && (
                <MagicGrid items={finalImages}>
                  {finalImages.map(image => (
                    <img
                      src={image}
                      alt=""
                      className=""
                      style={{ maxWidth: '300px' }}
                      key={image}
                    />
                  ))}
                </MagicGrid>
              )} */}
            </div>
          ) : (
            <div>
              {!!layoutSectionContentItem?.sliderGallery && (
                <Slider {...settings} className="">
                  {layoutSectionContentItem?.sliderGallery.map(image => (
                    <img
                      src={image.url}
                      alt=""
                      className="w-12 slider-image"
                      key={Math.random()}
                    />
                  ))}
                </Slider>
              )}
            </div>
          )}

          {!!layoutSectionContentItem?.contactForm && (
            <ContactFormSection
              contactFormData={layoutSectionContentItem.contactForm}
            />
          )}
          {!!layoutSectionContentItem?.logoTableSection && (
            <div>
              {layoutSectionContentItem.logoTableSection.map(
                logoTableSectionItem => (
                  <LogoTable
                    title={
                      logoTableSectionItem.logoTableSectionTitle &&
                      logoTableSectionItem.logoTableSectionTitle
                    }
                    query={logoTableSectionItem.logoTableSectionQuery}
                    key={Math.random()}
                  />
                ),
              )}
            </div>
          )}
          {layoutSectionContentItem?.displayBlogSection && (
            <div className="relative texture-background texture-right overflow-hidden">
              <section className="container my-8 px-4 dark-section">
                <BlogGridSlider
                  fromHomePage
                  blogHeader={
                    layoutSectionContentItem?.blogSectionTitle || 'Blogs'
                  }
                />
              </section>
            </div>
          )}
          {!!layoutSectionContentItem?.standOutText && (
            <div className="home-standout-text-wrapper gradient-bkg">
              <section className="container py-8 flex align-items-center justify-content-center">
                {isMobile ? (
                  <h3 className="home-standout-text text-shadow text-center mx-auto w-10 md:w-6">
                    {layoutSectionContentItem.standOutText}
                  </h3>
                ) : (
                  <h3 className="home-standout-text text-shadow">
                    <Fade
                      cascade
                      triggerOnce
                      duration={100}
                      className="text-center mx-auto w-10 md:w-6">
                      {layoutSectionContentItem.standOutText}
                    </Fade>
                  </h3>
                )}
              </section>
            </div>
          )}
          {layoutSectionContentItem?.memberSelect &&
            layoutSectionContentItem?.memberSectionTitle &&
            layoutSectionContentItem?.memberCardLayout && (
              <Member
                memberSectionTitle={layoutSectionContentItem.memberSectionTitle}
                memberSelect={layoutSectionContentItem.memberSelect}
                memberCardLayout={layoutSectionContentItem.memberCardLayout}
              />
            )}
          {layoutSectionContentItem?.displayWhatsappFloat && <Whatsapp />}
          {layoutSectionContentItem?.displayMusicSection && (
            <FeatureAlbum
              albumMap={layoutSectionContentItem?.displayMusicSection}
            />
          )}
          {layoutSectionContentItem?.displayAllMusic && <Albums />}
          {layoutSectionContentItem?.mailchimpLink && (
            <div className="gradient-bkg m-0 p-0">
              <section className="container py-8 flex align-items center jutsify-content-center">
                <div className="flex flex-column align-items-center text-center w-full md:w-6 mx-auto">
                  <Fade triggerOnce direction="up" className="w-full">
                    <Mailchimp
                      float={false}
                      title={layoutSectionContentItem?.mailchimpTitle}
                      subtitle={layoutSectionContentItem?.mailchimpSubtitle}
                    />
                  </Fade>
                </div>
              </section>
            </div>
          )}
          {layoutSectionContentItem?.displayInstagramSectionUsername && (
            <InstagramSection
              IGUsername={
                layoutSectionContentItem.displayInstagramSectionUsername
              }
            />
          )}
          {!!layoutSectionContentItem?.heroMediaSlider && (
            <HeroMediaSliderSection
              heroMediaSliderData={layoutSectionContentItem.heroMediaSlider}
            />
          )}
        </div>
      ))}
    </div>
  );
}
